export default import.meta.ROLLDOWN_FILE_URL_owkCfKX4JTjmWE2UA1sNeQ